(function () {
  function init(root) {
    var toggle = root.querySelector('.lachi-cf-toggle');
    var box = root.querySelector('.lachi-cf-fields');
    if (!toggle || !box) return;

    var container = root.closest('.product-details') || root.closest('.shopify-section') || document;
    var form = container.querySelector('form[id^="BuyButtons-ProductForm-"]');
    if (!form) return;

    var fields = [].slice.call(box.querySelectorAll('input'));

    var formId = form.id;
    toggle.setAttribute('form', formId);
    fields.forEach(function (i) {
      i.setAttribute('form', formId);
      i.disabled = true;
    });

    function sync() {
      box.hidden = !toggle.checked;
      fields.forEach(function (i) {
        i.disabled = !toggle.checked;
        if (i.type === 'number') i.required = toggle.checked;
      });
    }
    toggle.addEventListener('change', sync);
    sync();

    var feeVariantId = Number(root.getAttribute('data-fee-variant-id'));

    document.addEventListener(
      'submit',
      function (evt) {
        if (evt.target !== form) return;
        if (!toggle.checked) return;

        evt.preventDefault();
        evt.stopPropagation();

        var addBtn = form.querySelector('button[type="submit"]');
        if (addBtn) addBtn.disabled = true;

        var fd = new FormData(form);
        var props = {};
        fd.forEach(function (value, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m && value) props[m[1]] = value;
        });

        var mainItem = { id: fd.get('id'), quantity: Number(fd.get('quantity')) || 1, properties: props };
        var items = [mainItem, { id: feeVariantId, quantity: 1 }];

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (r) {
            if (!r.ok) {
              return r.json().then(function (d) {
                throw new Error((d && (d.description || d.message)) || 'add failed');
              });
            }
            return r.json();
          })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function () {
            if (addBtn) addBtn.disabled = false;
            window.alert('Sorry, something went wrong adding this to your cart. Please try again.');
          });
      },
      true
    );
  }

  var instances = document.querySelectorAll('.lachi-customfit');
  for (var i = 0; i < instances.length; i++) init(instances[i]);
})();
